import { Controller } from "@hotwired/stimulus";
import "ninja-keys"

/**
 * Admin의 Command Palette를 위한 Controller
 */
export default class CommandPaletteController extends Controller {
  static values = {
    commands: Array
  }

  connect() {
    this.element.data = this.commandsValue.map(this.#convertToCommand)
  }

  /**
   * Rails ERB에서 주입받은 command를 ninja-keys에서 사용할 수 있도록 변환한다.
   *
   * @param command {{id: string, title: string, path: string, open_in_new_tab: boolean, mdIcon?: string}}
   */
  #convertToCommand(command) {
    let element = {
      id: command.id,
      sections: command.id,
      title: command.title,
    }

    if (command.mdIcon) {
      element.mdIcon = command.mdIcon
    }

    if (command.open_in_new_tab) {
      element.mdIcon = "link"
      element.handler = () => {
        window.open(command.path, "_blank")
      }
    } else {
      element.handler = () => {
        window.location.href = command.path
      }
    }

    return element
  }
}